export default "__VITE_ASSET__71aec7c1__"